import { DataSourceMode, EditRowDecorator, Layout } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommGroupFilter } from "./autogen/AutogenLayoutMobileCommGroupFilter";

interface MobileCommGroupFilterOptions {
    // this is a comment
    groupId: string;
}

export class MobileCommGroupFilter extends AutogenLayoutMobileCommGroupFilter {
    private _groupId: string;

    constructor(props?) {
        super(props);
        this._groupId = props?.groupId;
    }

    override async onLoad(): Promise<void> {
        await this.searchData();
    }

    private async searchData() {
        const response = await this.mainDataSource.search({
            "id": this._groupId,
        });
    }

    public static async showSlider(options: MobileCommGroupFilterOptions) {
        const {groupId} = options;
        const slideOutTitle = "Mobile Comm Group Filter " + options.groupId;
        const slideOutWidth = 1200;
        const endpointName = "lme/dispatch/mobilecomm/MobileCommGroupFilter";
        const layoutProps = {groupId};
        const groupFilterLayout = Layout.getLayout(endpointName, layoutProps as any) as MobileCommGroupFilter;
        const erd = new EditRowDecorator({
            layout: groupFilterLayout,
            title: slideOutTitle,
            layoutLoadListeners: event => {
                const groupRow = new ModelRow("lme/dispatch/mobilecomm/mc-group", false, null);
                groupFilterLayout.displayData(groupRow, null, 0);
                groupFilterLayout.mainDataSource.search({ id: groupId })
                groupFilterLayout.mainDataSource.mode = DataSourceMode.UPDATE;
                groupFilterLayout.sourceMCGroup.mode = DataSourceMode.UPDATE;
            },
            width: slideOutWidth,
            overlayProps: { closeOnClickOff: false, greyedBackground: true },
            dataSourceMode: DataSourceMode.UPDATE,
            onSave: (updatedData: ModelRow | any) => {
                groupFilterLayout.mainDataSource.post().then(result => {
                    groupFilterLayout.slideOut();
                });
            },
            onClose: (cancelled: boolean) => {
                groupFilterLayout.slideOut()
            },
        });
    }
}
